import "@hotwired/turbo-rails"
import "./controllers"

// Preserve scroll position on checkout pages when a form redirects back to the same page
// (e.g. editing a section on the confirmation page). Skip restoration when navigating
// to a different checkout step (progress buttons, continue/complete buttons).
document.addEventListener("turbo:before-fetch-request", (event) => {
  if (event.target.tagName === "FORM" && event.target.action.includes("/checkout")) {
    sessionStorage.setItem("checkoutScrollY", window.scrollY.toString())
    sessionStorage.setItem("checkoutScrollPath", window.location.pathname)
  }
})

document.addEventListener("turbo:load", () => {
  const savedScrollY = sessionStorage.getItem("checkoutScrollY")
  const savedPath = sessionStorage.getItem("checkoutScrollPath")
  sessionStorage.removeItem("checkoutScrollY")
  sessionStorage.removeItem("checkoutScrollPath")
  if (savedScrollY && savedPath === window.location.pathname) {
    window.scrollTo(0, parseInt(savedScrollY, 10))
  }
})
